var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CCard',[_c('CCardBody',[_c('h5',{staticClass:"text-primary"},[_vm._v("Top 10 Most Applied Programs")]),_c('div',[_c('BasicBar',{attrs:{"data":_vm.rankedChartData,"height":300,"showLegend":false}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }